import { useEffect } from "react";

const SITE_NAME = "daftar.fyi Admin";

export function useDocumentTitle(title?: string): void {
  useEffect(() => {
    const previousTitle = document.title;

    if (title) {
      document.title = `${SITE_NAME} - ${title}`;
    } else {
      document.title = SITE_NAME;
    }

    return () => {
      document.title = previousTitle;
    };
  }, [title]);
}
